import { Modal } from "react-bootstrap";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { Spin } from "antd";
import { generateFinancialReport } from "../../../api/studentPaiement";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const FinancialReportModalApercu = ({ show, metaData, onClose }: Props) => {
  const { selectedYear } = useAcademicYear();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);

  // Fontion pour générer un relevé denotes selon la périod , année academique , la classe et l'étudiant
  const generateFinancialRapport = async () => {
    setIsLoading(true);
    try {
      const payload = {
        id_academicYear: selectedYear?.id,
        id_studentProfil: metaData?.id,
      };
      const response = await generateFinancialReport(
        payload,
        buildPermissionContext(Resource.PAYMENT, Action.READ),
      );
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      // console.log("relevé généré: ", response);
      toast.success("Fiche généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération fiche: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false); // ← Toujours arrêter le chargement à la fin
    }
  };

  useEffect(() => {
    if (show) {
      generateFinancialRapport();
    } else {
      setPdfBlobUrl(null);
    }
  }, [show, metaData]);

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Rapport Financier {metaData?.firstName} {metaData?.lastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {!pdfBlobUrl && isLoading ? (
              <Spin
                indicator={
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                }
              />
            ) : (
              <iframe
                src={pdfBlobUrl || ""}
                style={{ width: "100%", height: "100%" }}
                // title="Aperçu PDF"
                title="Aperçu PDF Rapport Financier"
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  FinancialReportModalApercu,
  [buildPermission(Resource.PAYMENT, Action.READ)],
  "masquer",
);
